export const calculateExpensesTotalPrice = (data, currency) => {
  let val = 0;

  data.forEach((dt) => {
    val += (currency === 'IQD' ? dt.iqd : dt.price) || 0;
  });
  return val;
};
